import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { BoVisitor } from '../../bos/bo-visitor.js'
import { Block } from '../index.js'
import { TabGroupTabBlock } from './tab-group-tab-block.js'
import type { EventType } from '../../types.js'
import type { TsCodeType } from '../../types.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { Expression } from '../../data/text-or-code.js'

export const AnimationDurationMsDefault = 300

@jsonClass('TabGroupBlock')
export class TabGroupBlock extends Block {
	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 3,
		label: 'Selected tab ID',
		tooltip: () => ({
			text: 'Only used if you want to programmatically set or get the selected tab',
		}),
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: true,
		isMandatory: () => false,
	})
	selectedTabIdCode = new Expression()

	@jsonProperty(Expression)
	@ScreenEditorInput({
		order: 1,
		label: `Animation duration (ms; default ${AnimationDurationMsDefault})`,
		inputType: 'code',
		codeLanguage: 'ts',
		tsReturnType: () => 'number',
		editorSize: 'singleline',
		isBinding: false,
	})
	animationDurationMsCode = new Expression()

	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 2,
		label: 'Stretch tabs',
	})
	@jsonProperty(Boolean)
	stretchTabs: boolean = false

	constructor(init: Partial<TabGroupBlock> = {}) {
		super()
		this.init(init)
	}

	static createNewForEditor(): Block {
		return new this({
			children: [TabGroupTabBlock.createNewForEditor()],
		})
	}

	canHaveChild(child: Block): boolean {
		return child instanceof TabGroupTabBlock
	}

	getEditorCategory(): string {
		return 'Screen Structure'
	}

	get allowedEventTypes(): EventType[] {
		return [{ name: 'selectedIndexChange' }]
	}
}
